import { LectureVariants } from '@/enums/LectureVariants';
import { ThinLecture } from '@/resources/ThinLecture';

export const getLectureVariant = (lecture: ThinLecture) => {
  if (!lecture) return null;

  const hasVideo = Boolean(lecture?.playlist);
  const hasPoster = Boolean(lecture?.posterDocument?.url);

  if (hasVideo && hasPoster) {
    return LectureVariants.Full;
  }

  if (hasVideo) {
    return LectureVariants.Video;
  }

  if (hasPoster) {
    return LectureVariants.Poster;
  }

  return LectureVariants.Empty;
};
